import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Site\CreateSiteController::__invoke
* @see app/Http/Controllers/Site/CreateSiteController.php
* @route '/api/site'
*/
const CreateSiteController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateSiteController.url(options),
    method: 'post',
})

CreateSiteController.definition = {
    methods: ["post"],
    url: '/api/site',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Site\CreateSiteController::__invoke
* @see app/Http/Controllers/Site/CreateSiteController.php
* @route '/api/site'
*/
CreateSiteController.url = (options?: RouteQueryOptions) => {
    return CreateSiteController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Site\CreateSiteController::__invoke
* @see app/Http/Controllers/Site/CreateSiteController.php
* @route '/api/site'
*/
CreateSiteController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateSiteController.url(options),
    method: 'post',
})

export default CreateSiteController